// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__62tOo","inner":"Footer_inner__UAzUO","nextIcon":"Footer_nextIcon__f9XZn","innerLeft":"Footer_innerLeft__htuYv"};